<template>
  <div>
    <!-- dialog para inserção de senha -->
    <p-file-password-dialog ref="pDelete" :dialog="passDialog" @passChangeConfirm="(pass) => {passChangeConfirm(pass)}" @passChangeCancel="passChangeCancel"></p-file-password-dialog>
    
    <!-- dialog para exclusão d eum arquivo -->
    <p-confirm text="Tem certeza que deseja excluir esse arquivo" :dialog="dialogConfirm" @confirm="(editedItem.user_id === ($auth.check() ? $auth.user().id : editedItem.user_id) || editedItem.password === null) ? deleteItem() : initPassDialog(editedItem, 2, 2)" @cancel="closeDialogDelete"></p-confirm>
    <label v-if="blackLabel" class="p-label">{{label ? label : 'Arquivos'}}</label>
    <label v-else :class="error ? 'error--text v-label theme--light' : 'v-label theme--light'">{{label ? label : 'Arquivos'}}</label>
    <br>
    <div class="my-2" v-if="disabled">Campo de arquivo bloqueado</div>
    <div class="my-2" v-else-if="canAdd"><a @click="onFocus">Adicionar arquivo</a></div>
    <input v-show="false" :id="id" :rules="rules" type="file" multiple :disabled="disabled" ref="fileInput" @change="onFileChange">
    <!-- // Existe o v-text-field para funcionar as validações -->
    <v-text-field v-show="false" :value="customField['files']" :rules="rules"></v-text-field>
    <div v-if="error" class="v-text-field__details">
        <div class="v-messages theme--light" :class="error ? 'error--text' : ''">
          <div class="v-messages__wrapper">
            <div class="v-messages__message">O campo "{{label}}" é obrigatório</div>
          </div>
        </div>
    </div>
    <v-list one-line subheader dense v-if="customField">
      <!-- <v-progress-linear v-if="customField['files']" height="20" :color="progress['begin'] < items.length ? 'primary' : 'green'" :value="progress['begin']/items.length*100">
      <p class="text-xs-center">{{(progress['begin'] > items.length) ? items.length : progress['begin']}} de {{items.length}} {{progress['begin'] >= items.length ? ' - Concluido' : ''}}</p>
      </v-progress-linear> -->
      <v-progress-linear v-if="customField && customField['loading_files']" color="primary" height="2" :value="customField['loading_files_values']"></v-progress-linear>
      <template v-for="(item, index) in customField['files']">
        <v-hover :key="index + 2000">
          <v-list-tile :key="index" avatar @click="" slot-scope="{ hover }" class="small-list">
            <v-menu absolute offset-y>
              <template v-slot:activator="{ on }">
                <v-list-tile-avatar v-on="on">
                  <v-btn v-if="item['error']" fab color="#a60b0b8c" style="width: 30px;height: 30px;">
                    <v-icon color="#fff">priority_high</v-icon>
                  </v-btn>
                  <v-progress-circular
                    slot="activator"
                    v-else-if="item.loading_upload"
                    :value="item.loading_value_upload"
                    color="blue"
                  >{{ item.loading_value_upload }}</v-progress-circular>
                  <v-progress-circular
                    slot="activator"
                    v-else-if="item.loading_download"
                    :value="item.loading_value_download"
                    color="deep-purple"
                  >{{ item.loading_value_download }}</v-progress-circular>
                  <v-progress-circular
                    slot="activator"
                    v-else-if="item.loading_view"
                    :value="item.loading_value_view"
                    color="teal"
                  >{{ item.loading_value_view }}</v-progress-circular>
                  <v-btn v-else fab color="#00acc2" style="width: 30px;height: 30px;">
                    <v-icon color="#fff" v-if="hover">cloud_download</v-icon>
                    <v-icon color="#fff" v-else>{{avatarSrc(item.extension)}}</v-icon>
                  </v-btn>
                </v-list-tile-avatar>

                <v-list-tile-content v-on="on" v-if="item['error']">
                  <v-list-tile-title style="padding-top: 3px; color: #920000;">{{`${item['id_text']}.${item['extension']}`}}</v-list-tile-title>
                  <v-list-tile-sub-title><span style="color: gray; font-size:11px;">{{item['error']}}</span></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content v-on="on" v-else>
                  <v-list-tile-title style="padding-top: 3px;"><a>{{`${item['id_text']}.${item['extension']}`}}</a> </v-list-tile-title>
                  <v-list-tile-sub-title><span style="color: gray; font-size:11px;">{{(item['size'] / 1000000).toFixed(2)}} MB</span></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>

              <v-list v-if="!item['error']">
                <v-tooltip bottom>
                  <v-list-tile @click="item.user_id == ($auth.check() ? $auth.user().id : 0) || item.password === null ? downloadItem(item, '', true) : initPassDialog(item, 4)" avatar :disabled="!'pdf.png.jpeg.jpg.ico.txt.sql'.includes(item.extension)" slot="activator">
                    <v-list-tile-avatar>
                      <v-icon color="teal">visibility</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Visualizar</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="'pdf.png.jpeg.jpg.ico.txt.sql'.includes(item.extension)">Visualizar</span>
                  <span v-else>Não é possível visualizar esse arquivo</span>
                </v-tooltip>
                
                <v-list-tile @click="item.user_id === ($auth.check() ? $auth.user().id : 0) || item.password === null ? downloadItem(item) : initPassDialog(item, 4)" avatar>
                  <v-list-tile-avatar>
                    <v-icon color="deep-purple">cloud_download</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>Baixar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-list-tile-action v-if="(item['create'] || canDelete) && (hover || $vuetify.breakpoint.smAndDown) && !item['loading_upload'] && !disabled">
              <v-tooltip bottom class="pr-3">
                <v-btn slot="activator" small flat icon @click="dialogDelete(item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>Excluir</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </v-hover>
      </template>
    </v-list>
  </div>
</template>
<script>
  /* eslint-disable eqeqeq, no-useless-escape */
  import plan from './../../mixin/plan'
  import access from './../../mixin/access'
  import PFilePasswordDialog from './../shared/PFilePasswordDialog.vue'
  import PConfirm from './../shared/PConfirm.vue'
  export default {
    mixins: [plan, access],
    components: {PFilePasswordDialog, PConfirm},
    props: {
      id: {
        type: String,
        default: 'file_id'
      },
      // origin_field_name task_id ou tasktemplate_id
      // origin_field_name: {
      //   type: String,
      //   default: 'tasktemplate_id'
      // },
      // value: {
      //   type: [Array, String]
      // },
      // custom_field usado quando o campo personalizado de file não esta no vueX, exemplo na msg automatica
      custom_field: {
        type: Object,
        default: () => { return null }
      },
      // formDataFiles usado para ter os arquivos com formData
      formDataFiles: {
        type: Object,
        default: () => { return null }
      },
      custom_field_id: {
        type: Number,
        default: 0
      },
      // Habilita o botão de delete, em alguns momentos ele deve vir desabilitado, exemplo quando está na automação de mensagem
      // obs:  Os arquivos adicionars na hora que não foram salvos, podem ser deletado
      canDelete: {
        type: Boolean,
        default: true
      },
      // Habilita o botão de adicionar, em alguns momentos ele deve vir desabilitado, exemplo quando está na automação de mensagem
      canAdd: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: 'Arquivo'
      },
      // passwordTask para quando ele é passado de fora do arquivo, exemplo no link da TaskLinkView que mostra os arquvios mas tem senha apenas pra entrar no link
      passwordTask: {
        type: String,
        default: ''
      },
      tasktemplate_automation_id_enc: {
        type: Number,
        default: null
      },
      // blackLabel usado para mudar o label pois quando o componente acima está em criação fica diferente
      blackLabel: {
        type: Boolean,
        default: false
      },
      required: {
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      crud_access: {
        type: Boolean,
        default: true
      },
      task_shared: {
        type: Boolean,
        default: false
      },
      rules: {}
    },
    data () {
      return {
        addFiles: null,
        deleteFiles: null,
        entity: 'files',
        error: false,
        actAfterPassword: 1,
        deletepass: '',
        editedItem: {},
        passDialog: false,
        dialogConfirm: false,
        password: ''
      }
    },
    methods: {
      onFocus () {
        if (!this.disabled) {
          this.$refs.fileInput.click()
        }
      },
      onFileChange ($event) {
        let files = $event.target.files || $event.dataTransfer.files
        this.addFiles = files
        this.$emit('addFiles', this.addFiles)
        // checa se é obrigatório para tirar o vermelho quando o usuário insere um item
        setTimeout(() => {
          this.checkRequired()
        }, 2000)
      },
      downloadItem (item, password = '', onlyView = false) {
        this.onlyView = onlyView
        // seta true para o loading começar a rodar
        this.$set(item, `loading_${onlyView ? 'view' : 'download'}`, true)
        this.$set(item, `loading_value_${onlyView ? 'view' : 'download'}`, 0)
        // verifica se existe o create pois se existir o item so foi adiciona porem não foi salvo no banco, com isso deve ser pego o valor direto do item para salvar
        if (item['create']) {
          // Primeiro verifica se possui os files pelo formDataFiles isso ocorre quando não é usado no vueX no caso de mensagens de automação
          let itemFormData = this.formDataFiles ? this.formDataFiles[item['custom_field_id']].find((val) => { return val.get('id') == item['id'] }) : this.$store.getters[`customField/getFile`](item['custom_field_id'], item['id'])

          if (itemFormData) itemFormData = itemFormData.get('file')
          // this.addFiles.getAll('files').find((val) => { return val['name'] === `${item['id_text']}.${item['extension']}` })
          let blob = new Blob([itemFormData])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          if (onlyView) {
            window.open(link, '_blank')
          } else {
            link.download = item.id_text + '.' + item.extension
            link.click()
          }
          item[`loading_${onlyView ? 'view' : 'download'}`] = false
        } else {
          // Caso não tenha o create significa que é um arquvio que já existe no servidor, portanto busca ele
          // Na parte do password primeiro verifica se tem o password do arquivo, se não tiver passa o this.password da props que veio do componente mae.
          this.$http.get(`api/${this.entity}/download/${item.id}?${item.task_id !== null ? `task=${item.task_id}&` : ''}shared=${false}&password=${password === '' ? btoa(this.passwordTask) : btoa(password)}&tasktemplate_automation_id_enc=${this.tasktemplate_automation_id_enc}`, {
            responseType: 'arraybuffer',
            progress (e) {
              if (e.lengthComputable) {
                item[`loading_value_${onlyView ? 'view' : 'download'}`] = Math.floor(e.loaded / e.total * 100)
              }
            }
          }).then(res => {
            let blob = new Blob([res.data], {type: res.headers.get('content-type')})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            if (onlyView) {
              window.open(link, '_blank')
            } else {
              link.download = item.id_text + '.' + item.extension
              link.click()
            }
            item[`loading_${onlyView ? 'view' : 'download'}`] = false
          }, err => {
            console.log(err)
            item[`loading_${onlyView ? 'view' : 'download'}`] = false
            if (err.status === 400) {
              this.$store.commit('snackbar/change_values', {
                text: 'Senha invalida!',
                color: 'warning',
                dialog: true
              })
            }
          })
        }
      },
      initPassDialog (item, after = 1) {
        this.passDialog = true
        this.dialogConfirm = false
        this.actAfterPassword = after
        // this.editedItem = {id: item.id, task_id: item.task_id, id_text: item.id_text, extension: item.extension}
        // if (view === 3) {
        //   if (item.password === null) this.password = ''
        //   else {
        //     this.fileLoading = true
        //     this.$http.get(`api/getFilePassword?id=${item.id}`).then(res => {
        //       this.editedItem['password'] = res.body
        //       this.password = this.editedItem['password'] === null ? '' : atob(this.editedItem['password'])
        //       this.$refs.pDelete.password = this.password
        //     })
        //     this.fileLoading = false
        //   }
        // }
      },
      passChangeConfirm (pass) {
        this.deletepass = btoa(pass)
        if (this.actAfterPassword === 1) this.downloadItem(this.editedItem, pass)
        if (this.actAfterPassword === 2) this.deleteItem(`?password=${this.deletepass}`)
        this.password = ''
        this.passDialog = false
      },
      passChangeCancel () {
        this.password = ''
        this.passDialog = false
      },
      dialogDelete (item) {
        // caso o item não tenha o create contrario é necessário verificar os acesso
        if (!item['create']) {
          if (this.task_shared || (!this.crud_access && item.user_id !== (this.$auth.check() ? this.$auth.user().id : item.user_id)) || (!this.checkPermission('files', 'delete'))) {
            this.$store.commit('snackbar/change_values', { text: 'Você não tem permissão para deletar esse item!', color: 'warning', timeout: 8000, dialog: true })
            return
          }
        }
        // Caso o item tenha o create significa que ele foi adicionado no momento, podendo ser excluido,
        this.editedItem = item
        this.dialogConfirm = true
      },
      closeDialogDelete () {
        this.dialogConfirm = false
        this.editedItem = {}
      },
      deleteItem (params = '') {
        this.$store.commit('loader/change_dialog', true)
        // Caso os campos tenham vindo do componente acima e não do vuex faz o tratamento neles, exemplo mensagem automatizada
        if (this.custom_field != null) {
          this.$emit('deleteFiles', this.editedItem)
          this.$store.commit('loader/change_dialog', false)
          this.closeDialogDelete()
        } else {
          // caso seja algum item que foi adicionado na hora apenas remove ele
          this.$store.dispatch('customField/delete_file', {id: this.editedItem['id'], custom_field_id: this.editedItem['custom_field_id'], save_bd: !this.editedItem['create'], params: params}).then(
            (file) => {
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' excluído com sucesso!', color: 'success', dialog: true })
              this.$socket.emit('generalDetailsEvent', {
                data: file,
                details: 'files',
                notBroadcast: true,
                responseEvent: 'deleteSocketDetails',
                room: `tasks${file['task_id']}_manage`
              })
              // Emitindo evento para deletar arquivo no campo personalizado
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'deleteFileCustomField',
                room: `tasks${file['task_id']}_manage`
              })
              // Enviando evento para a tela de arquivo
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'deleteSocketItem',
                room: `files${file['company_id']}`
              })
              this.closeDialogDelete()
            },
            err => {
              console.log(err)
              this.closeDialogDelete()
              this.$store.commit('loader/change_dialog', false)
              if (err.body.message === 'passwordDoesntMatch') {
                this.$store.commit('snackbar/change_values', { text: 'Senha invalida!', color: 'warning', dialog: true })
              } else {
                this.$store.commit('snackbar/change_values', { text: 'Não foi possível deletar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
              }
            }
          )
        }
      },
      // Função criada para que no componente pai chame e verifique se o pfile é obrigatório para mostrar a msg de erro
      checkRequired () {
        this.error = false
        if (this.required) {
          // verifica se não tem nenhum registro e aciona o erro
          if (!Array.isArray(this.customField['files']) || (Array.isArray(this.customField['files']) && this.customField['files'].length <= 0)) {
            this.error = true
          }
        }
      },
      avatarSrc (extension) {
        switch (extension) {
          case 'pdf': return 'picture_as_pdf'
          case 'png': case 'jpg': case 'jpeg': case 'gif': return 'image'
          case 'docx': case 'rtf': return 'description'
          case 'mp4': return 'videocam'
          default: return 'insert_drive_file'
        }
      }
    },
    computed: {
      // Pega os arquivos do vuex
      customField () {
        // verifica se o componente possui campos personalizados, significando que não vai vir do vuex exemplo mensagem da automação
        return this.custom_field != null ? this.custom_field : this.$store.state.customField.values.find((val) => { return val['id'] == this.custom_field_id })
      }
    }
  }
</script>

<style scoped>
  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PFile.vue